export default "__VITE_ASSET__CtATw5Z8__"